<template src="./group.html"></template>
<script>
  import Multiselect from "vue-multiselect";
  import Axios from "axios";
  import $ from "jquery";
  var moment = require("moment");
  export default {
    components: {
      Multiselect,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
          if (data != "" && data != null) {
            sendDate = moment(data).format("DD-MM-YYYY");
          }
          return sendDate;
      },
      date_time: function (data) {
        var sendDate = "N/A";
          if (data != "" && data != null) {
            sendDate = moment(data).format("DD-MM-YYYY h:mm A");
          }
          return sendDate;
      }
    },
    data() {
      return {
        basic: {
          currentPage: 1,
          totalPages: 0,
        },
        ShowLoader: false,
        SearchForm: {
          Name: "",
        },
        GroupList: [],
        Group: {},
        ShowGroupAddModel: "",
        SubmitGroup: {},
        ShowGroupAdd: false,
        ShowGroupEdit: false,
        ShowGroupDelete: false,
        VehicleImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
        ShowGroupAssetsListModel: false,
        ShowGroupQRModel: false,
        QRCodeEndpoint : Endpoints.QR.Generate+'?content=',
        ShowGroupHeadcountModel: false,
        AssetsList:[],
        HeadcountData:[],
        infoOpened: false,
        locationPoints: "",
        center: {
          lat: 55.232753,
          lng: -3.944403,
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
          content: "",
        },
      };
    },
    mounted() {
      var AccountPermissions = JSON.parse(
        localStorage.getItem("AccountPermissions")
      );
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)
      ) {
        this.$router.push("/");
      }

      if (
        AccountPermissions &&
        AccountPermissions.Assets &&
        AccountPermissions.Assets.enable
      ) {
        if (AccountPermissions.Assets.add) {
          this.ShowGroupAdd = true;
        }
        if (AccountPermissions.Assets.edit) {
          this.ShowGroupEdit = true;
        }
        if (AccountPermissions.Assets.delete) {
          this.ShowGroupDelete = true;
        }
      }
      if (!FleetSubscriptionModules["Hierarchy System"]) {
        this.ShowGroupAdd = true;
        this.ShowGroupEdit = true;
        this.ShowGroupDelete = true;
      }

      document.title = pbx_SiteTitle + " - Assets Group";
      this.GetGroupList();
    },

    methods: {
      initSubmitGroupObject() {
        this.SubmitGroup = {
          id: 0,
          name: "",
        };
      },
      GetGroupList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        if (type == "search") {
          obj.name = this.SearchForm.Name;
        }
        this.ShowLoader = true;
        Axios.post(Endpoints.Assets.Group.List, obj).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.GroupList = Response.data.GroupList;
          }
        });
      },
      AddNewGroup() {
        this.ShowGroupAddModel = true;
        this.initSubmitGroupObject();
      },
      EditGroup(Group) {
        this.ShowGroupAddModel = true;
        this.SubmitGroup = {};
        this.SubmitGroup.id = Group.id;
        this.SubmitGroup.name = Group.name;
      },
      AddGroupSubmit() {
        var error = false;
        var errorStr = "";
        if (!this.SubmitGroup.name) {
          error = true;
          errorStr += "<li>Please Enter Group Name</li>";
        }
        if (error == true) {
          this.$swal("Following Error Found!", errorStr, "error").then(
            () => {}
          );
        } else {
          this.$swal({
            title: "Adding Group...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          var postUrl = Endpoints.Assets.Group.Create;
          if (this.SubmitGroup && this.SubmitGroup.id > 0) {
            postUrl = Endpoints.Assets.Group.Update;
          }
          Axios.post(postUrl, {
            token: localStorage.getItem("token"),
            SubmitGroup: this.SubmitGroup,
          }).then((Response) => {
            if (Response?.data?.success == true) {
              this.ShowGroupAddModel = false;
              this.GetGroupList();
              this.initSubmitGroupObject();
              this.$swal("Group Added Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
            }
          });
        }
      },
      DeleteGroup(Group) {
        this.$swal
          .fire({
            title: "Are you sure You want to Delete this Group?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, Delete it!",
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Deleting Group...",
                text: "Please wait...",
                imageUrl: require("@/assets/images/LoadingTwo.gif"),
                showConfirmButton: false,
                allowOutsideClick: false,
              });

              Axios.post(Endpoints.Assets.Group.Delete, {
                token: localStorage.getItem("token"),
                id: Group.id,
              }).then((Response) => {
                if (Response?.data?.success == true) {
                  this.GetGroupList();
                  this.$swal("Group Deleted Successfully", "", "success").then(
                    () => {}
                  );
                } else {
                  this.$swal(Response?.data?.message || "Something went wrong", "", "error").then(() => {});
                }
              });
            }
          });
      },
      ShowGroupAssetsList(GroupId) {      	
        this.ShowGroupAssetsListModel = true;
        this.$swal({
            title: "Fetching Assets List...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
        });
       	Axios.post(Endpoints.Assets.List, {
            token: localStorage.getItem("token"),
            SearchData :{'group':GroupId},
        }).then((Response) => {
            if (Response?.data?.success == true) {
             	this.AssetsList = Response.data.AssetsList;
              	this.$swal.close();
            }
        });        
      },
      ShowGroupHeadcount(Headcount,GroupName) {      	
        this.ShowGroupHeadcountModel = true;
        this.HeadcountData = Headcount;
        this.HeadcountData.group_name = GroupName;
        if(this.HeadcountData.latitude != "" && this.HeadcountData.latitude != null ){
          const marker = {
            lat: parseFloat(this.HeadcountData.latitude),
            lng: parseFloat(this.HeadcountData.longitude),
          };
          this.center = marker,
          this.locationPoints = marker;
          this.infoOpened = true;
          this.infoOptions.content =
            '<div id="mapcontent"><h5 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
              GroupName +
            "</h5></div>";
            }
      },
      ShowGroupQRCode(Group) {
      	this.Group = Group;
        this.ShowGroupQRModel = true;        
      },
      getGroupQRCode(group){
        let data = {'id' :group.id, 'type':'group'};
        var qrurl = this.QRCodeEndpoint + btoa(JSON.stringify(data));
      	return qrurl;
      }
    },
  };
</script>
<style scoped>
.assets-list{
  display: block;
  margin: 15px 0;
}
.assets-list li{
  display: inline-block;
  width: 140px;
  text-align: center;

}
.assets-list a{
  display: block;
  padding: 5px;  
}
.assets-list a img{
  max-width: 100%;  
}
.assets-list .AssetName{
  color: #333;
  padding-top: 3px;
  margin-bottom: 10px;
}
</style>
